/**
 * 세션 생명주기 (data-model §6, FR-008/010/013).
 * idle → asking → playing → ended. 책상 위 물건을 모두 부수면 종료하고 결과 카드를 만든다.
 *
 * 리셋 정책(A1 명확화):
 *  - 플레이 중 리셋(resetInPlace): 책상·점수·콤보 초기화(이어서 플레이).
 *  - 종료 화면: 웹 페이지 공유만 제공(다시 하려면 새로고침).
 */
import type { EventBus } from '../core/EventBus';
import type { SessionPhase, ResultCard } from '../core/types';
import type { ScoreSystem } from './ScoreSystem';
import { pickQuip } from '../config/quips';
import { updateBest } from '../storage/records';

export class Session {
  phase: SessionPhase = 'idle';

  constructor(
    private bus: EventBus,
    private score: ScoreSystem,
  ) {}

  /** 시작 질문 화면으로. */
  openQuestion(): void {
    this.phase = 'asking';
  }

  /** 플레이 시작(사유 입력 없이 바로). */
  start(): void {
    this.phase = 'playing';
    this.bus.emit('session:start', {});
  }

  /** 책상 위 물건을 모두 부수면 종료(외부 all-broken 감지에서 호출). */
  finish(): void {
    this.end();
  }

  private end(): void {
    if (this.phase !== 'playing') return;
    this.phase = 'ended';
    const totalScore = this.score.state.score;
    const maxCombo = this.score.state.maxCombo;
    const { isNewBest } = updateBest(totalScore, maxCombo);
    const card: ResultCard = {
      totalScore,
      maxCombo,
      quip: pickQuip(totalScore, maxCombo),
      isNewBest,
    };
    this.bus.emit('session:end', { card });
  }

  /** 플레이 중 리셋: 책상/점수 복원. */
  resetInPlace(): void {
    if (this.phase !== 'playing') return;
    this.bus.emit('session:reset', {});
  }

  get isPlaying(): boolean {
    return this.phase === 'playing';
  }
}
